import { Component } from '@angular/core';
import { companyInformation } from '../../../companyinformation';
import { nav_path } from '../../../app-routing.module';
import { SeoService } from '../../../core/services/seo.service';

@Component({
  selector: 'anon-answers',
  templateUrl: './answers.component.html',
  styleUrls: ['./answers.component.scss']
})
export class AnswersComponent {
  public readonly companyInformation = companyInformation;
  public answers: { name: string, routerLink: string | string[] }[] = [
    { name: 'Disabled Comments', routerLink: nav_path.answersComments },
    { name: 'Story Distribution', routerLink: nav_path.answersStories }
  ];
  private title = "Answers page";

  constructor(private seo: SeoService) {
    seo.generateTags({
      title: this.title,
      description: `Anonymous Systems ${this.title}`,
      route: nav_path.answers
    });
  }
}
